import _toConsumableArray from "/home/runner/work/brand/brand/apps/docs/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/brand/brand/apps/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { iterateFocusableElements } from '@primer/behaviors/utils';
import { useProvidedRefOrCreate } from './useProvidedRefOrCreate';
export var useMenuInitialFocus = function useMenuInitialFocus(open, onOpen, providedRef) {
  var containerRef = useProvidedRefOrCreate(providedRef);

  var _React$useState = React.useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openingKey = _React$useState2[0],
      setOpeningKey = _React$useState2[1];

  var openWithFocus = function openWithFocus(gesture, event) {
    if (gesture === 'anchor-key-press' && event) setOpeningKey(event.code);else setOpeningKey(undefined);
    if (typeof onOpen === 'function') onOpen(gesture, event);
  };
  /**
   * Pick the first element to focus based on the key used to open the Menu
   * ArrowDown | Space | Enter: first element
   * ArrowUp: last element
   */


  React.useEffect(function () {
    if (!open) return;
    if (!openingKey || !containerRef.current) return;
    var iterable = iterateFocusableElements(containerRef.current);

    if (['ArrowDown', 'Space', 'Enter'].includes(openingKey)) {
      var firstElement = iterable.next().value;
      /** We push imperative focus to the next tick to prevent React's batching */

      setTimeout(function () {
        return firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
      });
    } else if (['ArrowUp'].includes(openingKey)) {
      var elements = _toConsumableArray(iterable);

      var lastElement = elements[elements.length - 1];
      setTimeout(function () {
        return lastElement.focus();
      });
    }
  }, [open, openingKey, containerRef]);
  return {
    containerRef: containerRef,
    openWithFocus: openWithFocus
  };
};